import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../common.service';

@Component({
	selector: 'app-com-tip',
	templateUrl: './app-com-tip.component.html',
	styleUrls: ['./app-com-tip.component.css']
})
export class AppComTipComponent implements OnInit {
	@Input() sureText:string = "确定";
	@Input() cancelText:string = "取消";
	@Input() desText:string = "";
	@Input() type: string;
	@Input() theme: string;
	@Output() onSure = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();
    @Output() outPutPrivate = new EventEmitter<any>();
    isHarmonyOS = false; //是否鸿蒙系统
	constructor(private commonService: CommonService) {
	}

	ngOnInit() {
		this.isHarmonyOS = this.commonService.isHarmonyOS();
   		this.theme = this.theme ? this.theme : 'dark';
	}

	sure(){
		this.onSure.emit();
	}

	cancel(){
		this.onCancel.emit();
	}

  check(){
	  if($('#private').hasClass('active')){
      $('#private').removeClass('active');
      this.outPutPrivate.emit(1);
    }else{
      $('#private').addClass('active');
      this.outPutPrivate.emit(0);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app-com-tip/app-com-tip.component.ts